module.exports = __webpack_public_path__ + "img/certificate-16a.803c726a.jpg";